import React from 'react';

function Services() {
  const services = [
    { title: 'IT Consulting', description: 'Strategic guidance for IT optimization.' },
    { title: 'Solution Architecture', description: 'Custom designs for scalable IT solutions.' },
    { title: 'Operational Excellence', description: 'Process optimization for efficiency.' },
    { title: 'Contact Center Migration', description: 'Seamless transitions with AWS technologies.' },
    { title: 'Unified Communications', description: 'Advanced systems for customer engagement.' },
    { title: 'AWS Cloud Services', description: 'Migration and optimization for scalability.' },
  ];

  return (
    <section id="services" className="py-16 bg-gray-100">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-8 text-blue-900">Our Services</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition">
              <h3 className="text-xl font-semibold text-blue-900 mb-2">{service.title}</h3>
              <p className="text-gray-700">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;